import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { browseCategoriesForNav } from '../categoryLabels';
import { categoryBrowsePath } from '../categoryPaths';
import { SITE_BETA_DISCLAIMER } from '../constants/siteDisclaimer';
import { trackSelectCategory } from '../ga';
import { FacebookFollowLink } from './FacebookFollowLink';
import './SiteFooter.css';

export function SiteFooter({
  browseCategories = [],
  activeShopCategorySlug = '',
}) {
  const footerCategories = useMemo(
    () => browseCategoriesForNav(browseCategories, activeShopCategorySlug),
    [browseCategories, activeShopCategorySlug],
  );

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__col">
          <h2 className="site-footer__heading">Shop by category</h2>
          <ul className="site-footer__links">
            {footerCategories.map((c) => (
              <li key={c.slug}>
                {c.comingSoon ? (
                  <span
                    className="site-footer__link site-footer__link--coming-soon"
                    title="Coming soon"
                  >
                    {c.name}
                  </span>
                ) : (
                  <Link
                    className="site-footer__link"
                    to={categoryBrowsePath(c.slug)}
                    onClick={() => trackSelectCategory(c.slug, 'footer')}
                  >
                    {c.name}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>

        <div className="site-footer__col site-footer__col--stack">
          <div className="site-footer__section">
            <h2 className="site-footer__heading">About</h2>
            <p className="site-footer__blurb">
              shops.mt is Malta&apos;s dedicated shopping search engine. Browse
              products from local retailers, compare prices, and shop from the
              stores you trust — all in one place.
            </p>
            <Link className="site-footer__link site-footer__link--cta" to="/about">
              Learn more &rarr;
            </Link>
          </div>

          <div className="site-footer__section">
            <h2 className="site-footer__heading">For shop owners</h2>
            <p className="site-footer__blurb">
              List your Maltese online shop on shops.mt and reach shoppers who
              are already searching with intent.
            </p>
            <Link className="site-footer__link site-footer__link--cta" to="/add-store">
              Get started &rarr;
            </Link>
            <p className="site-footer__blurb">
              Prefer not to be listed? Email{' '}
              <a className="site-footer__link" href="mailto:info@shops.mt">
                info@shops.mt
              </a>{' '}
              and we&apos;ll remove your store promptly.
            </p>
          </div>
        </div>

        <div className="site-footer__col">
          <h2 className="site-footer__heading">Stay updated</h2>
          <p className="site-footer__blurb">
            Malta deals, new stores, and price drops — in your feed.
          </p>
          <FacebookFollowLink variant="footer" location="footer" />
        </div>

        <div className="site-footer__col">
          <h2 className="site-footer__heading">Contact</h2>
          <a className="site-footer__link" href="mailto:info@shops.mt">
            info@shops.mt
          </a>
        </div>
      </div>

      <div className="site-footer__disclaimer">
        <span className="site-footer__beta-badge">BETA</span>
        <p className="site-footer__disclaimer-text">{SITE_BETA_DISCLAIMER}</p>
      </div>
    </footer>
  );
}
